export default __webpack_public_path__ + "static/media/ico_avisoprivacidad.3004cafb.svg";